import { isOfflineLocalSession } from '@/utils/offline-recording/localSessionSettings';
import type { QuerySessionResponse } from '@heidi/session/contracts';

/**
 * Whether this session's settings can be written through to the backend right
 * now: it has a server record (not an offline-local session that only exists in
 * the RQ cache) AND the app has a reachable backend.
 *
 * Gate ONLY server-touching work on this. Client-side work — optimistic cache
 * writes, local bridge writes, pending-store records, analytics — must keep
 * running when this returns false, or the offline experience regresses.
 */
export function canPersistSessionToServer(
  cachedSession: QuerySessionResponse | undefined,
  isOffline: boolean
): boolean {
  return !isOfflineLocalSession(cachedSession) && !isOffline;
}
